import { format, formatDistanceToNowStrict, parseISO } from 'date-fns';

const numberFmt = new Intl.NumberFormat('en-US');

export function formatNumber(n: number): string {
  return numberFmt.format(n);
}

export function formatCompact(n: number): string {
  return new Intl.NumberFormat('en-US', { notation: 'compact', maximumFractionDigits: 1 }).format(n);
}

export function formatPercent(ratio: number, digits = 1): string {
  return `${(ratio * 100).toFixed(digits)}%`;
}

export function formatDate(iso?: string | null): string {
  if (!iso) return '—';
  try {
    return format(parseISO(iso), 'dd MMM yyyy');
  } catch {
    return '—';
  }
}

export function formatDateTime(iso?: string | null): string {
  if (!iso) return '—';
  try {
    return format(parseISO(iso), 'dd MMM yyyy, HH:mm');
  } catch {
    return '—';
  }
}

// SL_002: date + time WITH the viewer's timezone, so an expiry instant is
// unambiguous (the value is stored as UTC and rendered in local time here).
export function formatDateTimeTz(iso?: string | null): string {
  if (!iso) return '—';
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return `${format(parseISO(iso), 'dd MMM yyyy, HH:mm')} (${tz})`;
  } catch {
    return '—';
  }
}

export function formatRelative(iso?: string | null): string {
  if (!iso) return '—';
  try {
    return `${formatDistanceToNowStrict(parseISO(iso))} ago`;
  } catch {
    return '—';
  }
}

// SM_012: value for an <input type="datetime-local"> min= attribute — the local
// wall-clock "now" as YYYY-MM-DDTHH:mm (no seconds, no timezone), so the picker
// cannot select a past instant. datetime-local compares against local time, so we
// format in local time (not toISOString, which is UTC and would shift the floor).
export function toDatetimeLocalValue(d: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return (
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}` +
    `T${pad(d.getHours())}:${pad(d.getMinutes())}`
  );
}

/** Hostname of a URL for compact display; falls back to the raw string. */
export function hostOf(url: string): string {
  try {
    return new URL(url).host;
  } catch {
    return url;
  }
}
